module.exports = __webpack_public_path__ + "media/recipes/20-77fdfdaa.png";